import { t } from 'ttag';

import { Modal } from '@ui/Modal';
import { Button } from '@ui/Button';

import s from './ConfirmSaleBigDiscountModal.sss';

interface Props {
  isOpen: boolean,
  isSubmitting?: boolean,
  onEditProduct: () => void,
  onConfirmSale: () => void,
  onClose: () => void,
}

export const ConfirmSaleBigDiscountModal: React.FC<Props> = ({
  isOpen,
  isSubmitting,
  onEditProduct,
  onConfirmSale,
  onClose,
}) => (
  <Modal
    className={s.modal}
    isOpen={isOpen}
    withClose={true}
    onRequestClose={onClose}
  >
    <p className={s.text}>
      {t`Ми помітили, що ви зробили покупцеві велику знижку.`}
    </p>
    <p className={s.text}>
      {t`Ви можете відмітити продаж з такою знижкою, але цей діалог потрапить на перевірку модераторам.`}
    </p>

    <div className={s.actions}>
      <Button
        className={s.button}
        theme="secondary"
        onClick={onConfirmSale}
        disabled={isSubmitting}
      >
        {t`Відмітити продаж`}
      </Button>
      <Button
        className={s.button}
        theme="primary"
        onClick={onEditProduct}
      >
        {t`Редагувати ціну`}
      </Button>
    </div>
  </Modal>
);
